import { useState, useEffect, useContext, useCallback } from 'react'

import { useSelector } from 'react-redux'

import ContactPersonSpecialitiesInstitutionWidget from '../../../Components/shared/ContactPersonSpecialitiesInstitutionWidget'
import { getMaccsContactPersons, getSpecialityYearsByInstitutionOnlyWithContactPerson } from '../../../utils/api/institution'
import ContactPersonTable from './ContactPersonTable'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { isEmptyArray } from '../../../utils'

const ContactPersonsInstitutionMaccs = () => {
  const { user } = useContext(GlobalContext)

  const t = useSelector(selectTranslate)

  const [contactPersons, setContactPersons] = useState([])
  const [optionsSelect, setOptionSelect] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedSpeciality, setSelectedSpeciality] = useState('all')
  const [selectedContactPersonSpeciality, setSelectedContactPersonSpeciality] = useState(null)

  const institution = isEmptyArray(user.institutions[0]) ? null : user.institutions[0]

  const fetchContactPersons = useCallback((parameters = {}) => {
    setLoading(true)

    getMaccsContactPersons(user, user.institutions[0], parameters).then(({ data }) => {
      setContactPersons(data)
      setLoading(false)
    })
  }, [user.id])

  useEffect(() => {
    fetchContactPersons({ specialityYears: selectedSpeciality !== 'all' ? [selectedSpeciality] : [] })
  }, [fetchContactPersons, selectedSpeciality])

  useEffect(() => {
    if (!isEmptyArray(user.institutions)) {
      getSpecialityYearsByInstitutionOnlyWithContactPerson(user, user.institutions[0]).then(({ data }) => {
        data.map(specialityYear => {
          specialityYear.name = specialityYear.specialityAbbreviation + ' (' + specialityYear.studyYearName + ')'
        })

        setOptionSelect(data)
      })
    }
  }, [user.id])

  const additionalActions = [
    {
      iconName: 'graduation-cap',
      type: 'primary',
      title: t('Display specialities for this user'),
      onClick: u => setSelectedContactPersonSpeciality(u)
    }
  ]

  return (
    <>
      <ContactPersonTable
        contactPersons={contactPersons}
        loading={loading}
        additionalActions={additionalActions}
        selectValue={selectedSpeciality}
        onChangeSelect={setSelectedSpeciality}
        allOptionText={t('All specialities')}
        optionsSelect={optionsSelect}
      />
      <ContactPersonSpecialitiesInstitutionWidget
        user={selectedContactPersonSpeciality}
        institution={institution.id}
        onClose={() => setSelectedContactPersonSpeciality(null)}
      />
    </>
  )
}
export default ContactPersonsInstitutionMaccs
